
interface ErrorEnvelope {
    errorCode?: string;
    errorMessage?: string;
    validationMessages?: ValidationMessage[];
    statusCode?: number
}

export class ApiError extends Error {

    public errorCode?: string;
    public errorMessage?: string;
    public validationMessages?: ValidationMessage[];
    public statusCode?: number;

    constructor(envelope: ErrorEnvelope) {

        super(envelope.errorMessage || "Validation failed");

        this.errorCode = envelope.errorCode;
        this.errorMessage = envelope.errorMessage;
        this.validationMessages = envelope.validationMessages;
        this.statusCode = envelope.statusCode

        Object.setPrototypeOf(this, ApiError.prototype);
    }
}

export type ValidationMessage = {
    field: string;
    message: string;
};